import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import Scroll from 'react-scroll'
import { Icon } from './Icon'
import { Href } from '../components'
const scroll = Scroll.animateScroll
const ScrollLink = Scroll.Link

const HeaderOuter = styled.nav`
  width: 100%;
  position: sticky;
  top: 70px;
  background: #ffffff;
  z-index: 1;
  box-shadow: ${props => props.show && '0px 1px 3px 1px rgba(155, 155, 155, 0.6)'};
  @media (max-width: 992px) {
    top: 50px;
  }
  @media (max-width: 768px) {
    box-shadow: none;
  }
`
const HeaderWrapper = styled.div`
  display: flex;
  padding: 0 80px;
  max-width: 1366px;
  margin: 0 auto;

  & a {
    text-decoration: none;
  }

  @media (max-width: 992px) {
    padding: 0 20px;
  }
  @media (max-width: 768px) {
    display: block;
    & a {
      padding: 5px;
      font-size: 12px;
      &:nth-child(2),
      :nth-child(1) {
        padding-left: 0px;
      }
    }
  }
  @media (max-width: 540px) {
    padding-left: 10px;
    padding-right: 10px;
    & a {
      font-size: 11px;
    }
  }
`
const LogoMenu = styled.div`
  display: flex;
  align-items: center;
  min-width: 165px;
  @media (max-width: 768px) {
    padding-top: 10px;
  }
`

const LogoLink = styled.a`
  cursor: pointer;
  & img {
    width: 84px;
    height: 34px;
  }
`
const Menu = styled.div`
  position: relative;
  @media (max-width: 768px) {
    border-bottom: 1px solid rgba(51, 51, 51, 0.1);
  }
`

const Eulalink = styled.span`
  a {
    color: #999999;
  }
`

const ScrollToContainer = styled(ScrollLink)`
  padding: 25px 15px 20px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1.4px;
  color: #999999;
  line-height: 1.64;
  position: relative;
  cursor: pointer;
  display: inline-block;
  min-width: 90px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.4s linear;
  :hover {
    color: #333;
  }
  @media (max-width: 540px) {
    min-width: auto;
  }
  &.active {
    color: #333333;
    &::after {
      content: '';
      width: 20px;
      height: 2px;
      position: absolute;
      left: calc(60% - 20px);
      background-color: #333333;
      bottom: 15px;
      border-radius: 0px;
    }
    @media (max-width: 768px) {
      &:after {
        width: calc(100% - 10px);
        left: 5px;
        bottom: 0px;
      }
      &:first-child {
        &:after {
          left: 0px;
        }
      }
    }
  }
`

class SecondaryHeader extends Component {
  state = {
    show: false
  }
  scrollToTop = () => {
    scroll.scrollToTop()
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }
  handleScroll = () => {
    if (window.pageYOffset >= 150) {
      this.setState({
        show: true
      })
    } else {
      this.setState({
        show: false
      })
    }
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  render() {
    const { show } = this.state
    return (
      <Fragment>
        <HeaderOuter show={show}>
          <HeaderWrapper>
            <LogoMenu>
              <LogoLink onClick={() => this.scrollToTop()}>
                {this.props.location.pathname === '/extract' ? (
                  <img src={require('../static/extract_logo.svg')} alt="" />
                ) : this.props.location.pathname === '/books' ? (
                  <img src={require('../static/books_logo.svg')} alt="" />
                ) : (
                  <Icon icon="trckr" width={32} height={32} />
                )}
              </LogoLink>
            </LogoMenu>
            <Menu>
              <ScrollToContainer activeClass="active" to="overview" smooth={true} offset={-200} spy={true}>
                overview
              </ScrollToContainer>
              <ScrollToContainer
                activeClass="active"
                to="features"
                smooth={true}
                spy={true}
                offset={-200}
                duration={500}>
                features
              </ScrollToContainer>
              <ScrollToContainer
                activeClass="active"
                to="howItWorks"
                smooth={true}
                spy={true}
                offset={-150}
                duration={500}>
                How it works?
              </ScrollToContainer>
              <ScrollToContainer
                activeClass="active"
                to="pricing"
                smooth={true}
                spy={true}
                offset={-150}
                duration={500}>
                Pricing
              </ScrollToContainer>
              <Eulalink>
                <Href href="/eula" target="_blank">
                  EULA
                </Href>
              </Eulalink>
            </Menu>
          </HeaderWrapper>
        </HeaderOuter>
      </Fragment>
    )
  }
}

export default withRouter(SecondaryHeader)



// WEBPACK FOOTER //
// ./src/components/SecondaryHeader.js